module.exports = __webpack_public_path__ + "img/kids.a31172f5.svg";